export default __webpack_public_path__ + "static/media/cookie-monster.7cbf592c.svg";